import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_NEW_PETITION_PAGE_ACCESS_EXPERIMENT = defineFcm('new_petition_page_access_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string', optional: true },
				mobileExperimentName: { type: 'string', optional: true },
				desktopExperimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({
		enabled: false,
		experimentName: undefined,
		mobileExperimentName: undefined,
		desktopExperimentName: undefined,
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'TBD',
		context: 'Petition Details',
		description: `Determines whether the new petition page (2024) experiment is active.

		Also specifies the name of the experiment, so this FCM can be used to reset which experiment we check.
		Note that the experiment must be defined in the /admin/experiments UI.

		See the RFC for the experiment log: https://change.atlassian.net/wiki/spaces/PDP/pages/3444375582/New+Petition+Page+2024+-+Gamma#How-variants-can-be-viewed%3A

		UPDATE 2024-10: In addition to "experimentName" we can specify a "mobileExperimentName" and "desktopExperimentName". If those are present in the FCM, then "experimentName" will not be checked. Users will be treated to the experiment that matches their user agent.`,
		import: false,
		template: {
			enabled: true,
			experimentName: 'new_petition_page_experiment_vN',
			mobileExperimentName: 'new_petition_page_experiment_vN_mobile',
			desktopExperimentName: 'new_petition_page_experiment_vN_desktop',
		},
	});
